import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useInvariableMemo } from '../invariable-hooks';
import { UrlParamsHandler } from './url-params-handler';

type StringParams<T extends Record<string, any>> = {
    [Prop in keyof T]: string | undefined;
};

function useUrlParams<T extends Record<string, string>>(): Readonly<StringParams<T>>;
function useUrlParams<T extends Record<string, any>>(parsers: UrlParamsHandler<T>): Partial<T>;
function useUrlParams<T extends Record<string, any>>(
    handler?: UrlParamsHandler<T>
): Partial<T> | Readonly<StringParams<T>> {
    const params = useParams();
    const memoHandler = useInvariableMemo(() => handler);

    return useMemo(() => {
        if (memoHandler) {
            return memoHandler.parse(params as any);
        }

        return params as Readonly<StringParams<T>>;
    }, [params, memoHandler]);
}

export { useUrlParams };
